<script setup>
import { Head } from '@inertiajs/vue3'
import AircraftSelector from '../Components/AircraftSelector.vue'
import SummaryStrip from '../Components/SummaryStrip.vue'
import MaintenanceCard from '../Components/MaintenanceCard.vue'
import PaymentsCard from '../Components/PaymentsCard.vue'
import AircraftMap from '../Components/AircraftMap.vue'
import DocumentsCard from '../Components/DocumentsCard.vue'
import TeamMessageCard from '../Components/TeamMessageCard.vue'
import PromoBanner from '../Components/PromoBanner.vue'

defineProps({
  aircraft: { type: Object, required: true },
  aircraftOptions: { type: Array, default: () => [] },
  summary: { type: Object, required: true },
  maintenance: { type: Object, required: true },
  payments: { type: Array, required: true },
  aircraftMap: { type: Array, required: true },
  documents: { type: Array, required: true },
  teamMessage: { type: Object, required: true },
})
</script>

<template>
  <Head title="Visão Geral" />

  <div class="space-y-6">
    <!-- Cabeçalho -->
    <header class="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
      <div class="space-y-4">
        <h1 class="text-2xl font-bold tracking-wide text-up-navy sm:text-3xl">
          VISÃO GERAL DA SUA AERONAVE
        </h1>
        <AircraftSelector :aircraft="aircraft" :options="aircraftOptions" />
      </div>

      <p class="shrink-0 border-t-2 border-up-orange pt-2 text-xs leading-relaxed tracking-[0.14em] text-slate-500 lg:border-t-0 lg:border-b-2 lg:pt-0 lg:pb-2 lg:text-right">
        DESEMPENHO<br />SEGURANÇA<br />TRANQUILIDADE
      </p>
    </header>

    <SummaryStrip :summary="summary" />

    <!-- Grade principal: 3 colunas no desktop, empilhada no mobile -->
    <div class="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3">
      <MaintenanceCard :maintenance="maintenance" />
      <PaymentsCard :payments="payments" />
      <AircraftMap :parts="aircraftMap" class="lg:col-span-2 xl:col-span-1" />

      <DocumentsCard :documents="documents" />
      <TeamMessageCard :message="teamMessage" />
      <PromoBanner class="lg:col-span-2 xl:col-span-1" />
    </div>
  </div>
</template>
